<template>
	<div class="row" id="controls">
		<div class="col-auto">
			<ul class="pagination pagination-sm">
				<li class='page-item'><a class='page-link' @click.prevent="first" href='#'> &lt;&lt; </a></li>
				<li class='page-item'><a class='page-link' @click.prevent="old" href='#'> &lt; Anterior</a></li>
				<li class='page-item'><a class='page-link'>{{ data.current_page }}/{{ data.last_page }}</a></li>
				<li class='page-item'><a class='page-link' @click.prevent="next" href='#'>Próxima > </a></li>
				<li class='page-item'><a class='page-link' @click.prevent="last" href='#'> >> </a></li>
			</ul>
		</div>

		<div class="col-auto">
			<div class="form-inline">
				<label for="select">Mostrar &nbsp</label>
				<select class="form-control form-control-sm" v-model="data.per_page" @change="change_rows">
	    			<option value="10">10</option>
	    			<option value="20">20</option>
	    			<option value="30">30</option>
	    			<option value="50">50</option>
	    			<option value="100">100</option>
					<option value="250">250</option>
					<option value="500">500</option>
					<option value="1000">1000</option>
	    		</select>
	    		<span>&nbsp por página.</span>
			</div>
		</div>

		<div class="col-auto ml-auto">
			<div class="form-inline">
				<label id="registros">{{ data.total }} registros</label>
			</div>
		</div>

		<div class="col-auto ml-auto">
			<div class="form-inline">
				<label for="toPage">Ir para página &nbsp</label>
				<input type="text" class="form-control form-control-sm" v-model="page" @change="to_page">
			</div>
		</div>
	</div>
</template>

<script>
    export default {
    	props: ["data"],

    	data() {
			return { page: "" }
		},

    	methods: {
    		first() { 
    			if ( this.data.current_page > 1 ){
    				this.$emit("refresh", `${this.data.per_page}?page=1&`);
				}
    		},

			old() {
				const page = this.data.current_page - 1;
				if ( page >= 1 ){
					this.$emit("refresh", `${this.data.per_page}?page=${page}&`);
				}
			},

			next() {
				const page = this.data.current_page + 1;
				if ( page <= this.data.last_page ){
					this.$emit("refresh", `${this.data.per_page}?page=${page}&`);
				}
			},

			last() { 
				if ( this.data.current_page < this.data.last_page ){
					this.$emit("refresh", `${this.data.per_page}?page=${this.data.last_page}&`);
				}
			},

			change_rows() {
				this.$emit("refresh", `${this.data.per_page}?`);
			},

			to_page() {
				if ( this.page <= this.data.last_page ){
					this.$emit("refresh", `${this.data.per_page}?page=${this.page}&`);
				}else{
					window.alert("Você está tentando navegar para uma página inexistente");
				}
			},
    	},
    }
</script>

<style scoted>
#controls {
	margin-top: 20px;
}

#registros {
	height: 32px;
	line-height: 32px;
}
</style>
